<template>
    <div class="deliver-form">
        <app-filters
            :types="mailTypes"
            :searchMails="searchMails"
            :cancelFilter="cancelFilter"
            :venue-id="venueId"
        />
        <div>
            <div class="alert alert-success" v-if="!theMails.length">
                ¡No hay datos!
            </div>
        </div>
        <app-delivered-mail-table
            :data="data"
            :view-mail="seeMore"
            :onChangePage="onChangePage"
            @sort="onSort"
        />

        <!-- Ver detalle de la correspondencia -->
        <app-pop-up id="view-email-more" title="Correspondencia">
            <div slot="body">
                <app-mail-card v-if="selectedMail" :mail="selectedMail" />
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

import vigilanceRepository from '../../../../../repositories/vigilance.repository'
import DeliveredMailFilters from './DeliveredMailFilters/DeliveredMailFilters.vue'
import DeliveredMailTable from './DeliveredMailTable/DeliveredMailTable.vue'
import MailCard from '../../MailCard/MailCard.vue'
export default {
    components: {
        appFilters: DeliveredMailFilters,
        appDeliveredMailTable: DeliveredMailTable,
        appMailCard: MailCard,
    },
    props: {
        clientId: {
            type: Number,
            default: 0,
        },
        venueId: {
            type: Number,
        },
    },
    data() {
        return {
            page: 1,
            selectedMail: '',
            theMails: [],
            data: {},
            filters: null,
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc',
            },
        }
    },
    watch: {
        accessPoint(val) {
            if (!val) return

            this.loadMails()
        },
    },
    computed: {
        ...mapGetters(['mailTypes']),
    },
    methods: {
        ...mapActions(['saveMailDelivery']),
        seeMore(item) {
            this.selectedMail = Object.assign({}, item)
            this.$bus.$emit('view-email-more.open')
        },
        loadMails() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            if (this.user.profile.slug === 'vigilante') {
                filters.venue = this.accessPoint.venue_id
            }
            const vr = Object.assign({}, vigilanceRepository)

            const clientId = !!this.clientId
                ? this.clientId
                : !!this.client
                ? this.client.id
                : 0

            if (!clientId) return

            vr.getDeliveredMailPaged(clientId, this.page, filters)
                .then(data => {
                    this.data = data
                    this.theMails = data.data
                })
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar la correspondencias'
                    )
                )
        },
        searchMails(filters) {
            this.filters = filters
            this.page = 1
            this.loadMails()
        },
        cancelFilter() {
            this.page = 1
            this.$bus.$emit('delivered-mail-filters.clear')
            this.filters = null
            this.loadMails()
        },
        onChangePage(page) {
            this.page = page
            this.loadMails()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadMails()
        },
        clear() {
            this.data = {}
            this.theMails = []
        },
    },

    created() {
        this.loadMails()
        this.load('mailTypes')
        this.$bus.$on('delivered-mails.load', this.loadMails)
    },
}
</script>
